import { useQuery } from "@tanstack/react-query";
import { API } from "@/config";
import { fetcher } from "@/shared/core-configs";
import * as XLSX from "xlsx";
import saveAs from "file-saver";
import { trackEvent } from "@/utils/firebase/analytics";

export const GET_AUDIT_LOGS_FETCH_KEY = "GET_AUDIT_LOGS_FETCH_KEY";

export const getAuditLog = async ({
  queryKey,
}: {
  queryKey: [string, { startDate: string; endDate: string }];
}) => {
  const [, { startDate, endDate }] = queryKey;
  const response = await fetcher(
    `${API.GESLUB}/download-audit-log?startDate=${startDate}&endDate=${endDate}`,
  );

  if (!response.status) {
    throw new Error("Error al obtener el archivo");
  }

  const csvText = await response.data;

  return new Promise((resolve, reject) => {
    try {
      const rows: string[][] = csvText
        .split("\n")
        .filter((row: string) => row.trim() !== "")
        .map((row: string) =>
          row.split(",").map((cell: string) => cell.replace(/^"|"$/g, "")),
        );

      resolve(rows);
    } catch (error) {
      reject(error);
    }
  });
};

export const useGetAuditLog = (startDate: string, endDate: string) => {
  return useQuery({
    queryKey: [GET_AUDIT_LOGS_FETCH_KEY, { startDate, endDate }],
    queryFn: () =>
      getAuditLog({
        queryKey: [GET_AUDIT_LOGS_FETCH_KEY, { startDate, endDate }],
      }),
    enabled: false,
  });
};

export const downloadAsExcel = (
  data: string[][],
  filename = "audit-log.xlsx",
) => {
  const worksheet = XLSX.utils.aoa_to_sheet(data);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Bitácora de auditoría");
  const excelBuffer = XLSX.write(workbook, {
    bookType: "xlsx",
    type: "array",
  });
  const blob = new Blob([excelBuffer], {
    type: "application/octet-stream",
  });
  saveAs(blob, filename);
  trackEvent("export", { type: "xlsx", module: "audit_log" });
};
